import { useState } from "react";
import { CopyIcon, CheckIcon } from "../../components/ui/Icons";

export function CodeBlock({ code, language = "json" }: { code: string; language?: string }) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="group relative rounded-xl bg-base ring-1 ring-elevated">
      <div className="flex items-center justify-between border-b border-surface px-4 py-2">
        <span className="font-mono text-xs text-muted">{language}</span>
        <button
          onClick={copy}
          className="flex items-center gap-1.5 rounded-lg px-2 py-1 text-xs text-muted transition-colors hover:bg-surface hover:text-secondary"
        >
          {copied ? <CheckIcon size={12} /> : <CopyIcon size={12} />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className="overflow-x-auto p-4">
        <code className="font-mono text-sm text-secondary">{code}</code>
      </pre>
    </div>
  );
}

export function Note({
  children,
  type = "info",
}: {
  children: React.ReactNode;
  type?: "info" | "warning";
}) {
  const colors =
    type === "warning"
      ? "border-warning/30 bg-warning/5 text-yellow-200"
      : "border-blue-500/30 bg-blue-500/5 text-blue-200";

  return (
    <div className={`rounded-xl border p-4 ${colors}`}>
      <p className="text-sm">{children}</p>
    </div>
  );
}
